import gql from 'graphql-tag';

export const ProfileHeader_GQL = gql`
  query($inst_id: String!, $audience_key: String!) {
    audience {
      audience(inst_id: $inst_id, userKeyConsolidated: $audience_key) {
        profile {
          firstName
          lastName
          birthDate
          gender
          currentHighSchool: currentSchool
          highSchoolLevelToday
          intendedEntryTerm: enrollTerm
          interestedMajor: major
          email
          phoneNumber: phone
          country
          zipcode: postal
          unweightedGPA: gpa
          sat
          act
          visitorType
          relativeInterestLevel
          lastDateActiveWithYouvisit
          lastDateActiveWithInstitution
        }
      }
    }
  }
`;
